import React from "react";
import {
  FormControl,
  TextField,
  Button,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";

export default function AddPrice(props) {
  const {
    priceLabel,
    price,
    currency,
    onPriceLabelChange,
    onPriceChange,
    onCurrencyChange,
    onSave,
  } = props;

  return (
    <Box sx={{ mt: 2 }}>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <TextField
          label="Prix"
          margin="normal"
          onChange={onPriceChange}
          variant="outlined"
          value={price}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mb: 2, minWidth: 120 }} variant="outlined">
        <InputLabel id="devise-label">Devise</InputLabel>
        <Select
          labelId="devise-label"
          id="devise-select"
          value={currency}
          onChange={onCurrencyChange}
          label="Devise"
        >
          <MenuItem value="chf">CHF</MenuItem>
          <MenuItem value="eur">EUR</MenuItem>
        </Select>
      </FormControl>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        {/* in order to handle different prices depending on the item (example : small pizza is 10 chf, large pizza is 15 chf), add the necessary input fields
        considering that there can be any item type that will be determined by the user himself */}
        <TextField
          label="Libellé du type de prix"
          margin="normal"
          variant="outlined"
          value={priceLabel}
          onChange={onPriceLabelChange}
        />
        <span style={{ fontSize: "0.8em", color: "#666" }}>
          (exemple : petite taille, grande taille, supplément fromage,
          supplément jambon, etc.)
        </span>
      </Box>

      <Button variant="contained" onClick={onSave}>
        Ajouter
      </Button>
    </Box>
  );
}
